import { Pagination } from "antd";
import React, { useEffect, useState } from "react";
import TagManager from "react-gtm-module";
import { useHistory } from "react-router-dom";
import Linktable from "../../component/linkpage";
import SearchLinks from "../../component/linkpage/search";
import Sidenav from "../../component/sidenav";
import "./linkInitiatives.scss";

function LinkInitiatives() {
  const history = useHistory();
  const [searchValue, setsearchValue] = useState("");
  const [response, SetResponse] = useState({
    pageCount: 0,
  });
  const [pageDetails, setPageDetails] = useState({
    page: 1,
    pageSize: 10,
    search: "",
  });
  const { pageCount, data } = response;
  const query = useHistory().location.search;
  const token = new URLSearchParams(query).get("token");

  const getLinkInitiatives = (queryParams) => {
    fetch(
      `${process.env.REACT_APP_API_URL}/actions${queryParams}&token=${token}`
    )
      .then((res) => res.json())
      .then((response) => {
        if (response?.statusCode && response?.statusCode === 402) {
          window.location.href = `/subscriptions?token=${token}`;
        } else {
          SetResponse(response);
        }
      })
      .catch((error) => {
        alert(error.message);
      });
  };

  useEffect(() => {
    if (token) {
      const { page, pageSize, search = "" } = pageDetails;
      if (pageDetails.page && pageDetails.pageSize) {
        getLinkInitiatives(`?page=${page}&limit=${pageSize}&search=${search}`);
      }
    } else {
      history.push("/not-found");
    }
  }, [query, pageDetails]);

  const handleSearch = (e) => {
    if (e.target.value) {
      const filterValue = e.target.value;
      setsearchValue(filterValue);
    } else {
      setsearchValue("");
      setPageDetails({ ...pageDetails, search: "" });
    }
  };

  const handleSearchlinks = () => {
    setPageDetails({ ...pageDetails, search: searchValue });
    const dataLayer = {
      event: "Filter",
      event_category: "Search",
      event_id: searchValue,
    };
    TagManager.dataLayer({ dataLayer });
  };

  const handlePageChange = (page, pageSize) => {
    setPageDetails({
      ...pageDetails,
      page,
      pageSize,
    });
  };

  return (
    <div className="d-flex  ">
      <Sidenav />
      <div className="flex-1 details-section">
        <div className="container">
          <SearchLinks
            placeholder="Search Link Initiatives"
            handleSearch={handleSearch}
            handleSearchlinks={handleSearchlinks}
          />
          <div>
            <Linktable linkInitiatives={data} />
          </div>
        </div>

        <Pagination
          onChange={handlePageChange}
          defaultCurrent={1}
          current={pageDetails.page}
          pageSize={pageDetails.pageSize}
          total={pageCount}
          showSizeChanger
          pageSizeOptions={[5, 10, 20]}
        />
      </div>
    </div>
  );
}

export default LinkInitiatives;
